import { useTheme } from '@mui/material';

export const TOPBAR_HEIGHT = 50;
export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      height: TOPBAR_HEIGHT,
    },
    spinner: {
      marginLeft: 0,
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: TOPBAR_HEIGHT,
    },
    logoContainer: {
      display: 'flex',
      margin: theme.spacing(0, 4, 0, 6.5),
      textDecoration: 'none',
    },
    logoImage: {
      height: 30,
    },
    navContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    rightContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    navItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      fontSize: 20,
      lineHeight: 1,
      width: TOPBAR_HEIGHT,
      height: TOPBAR_HEIGHT,
      cursor: 'pointer',
    },
  };
};
